import { TypedDataDomain } from "viem";
import { sepolia } from "viem/chains";

export enum Token {
    USDC = "USDC",
    USDT = "USDT",
    DAI = "DAI",
    USDS = "USDS",
}

export const getAddress = (chainId: number, token: Token): `0x${string}` => {
    if (chainId === sepolia.id) {
        switch (token) {
            case Token.USDC:
                return "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238";
            case Token.USDT:
                return "0x7169D38820dfd117C3FA1f22a697dBA58d90BA06";
            case Token.DAI:
                return "0x68194a729C2450ad26072b3D33ADaCbcef39D574";
            case Token.USDS:
                return "0x45aC4be0F08E70d6a52F36e59f39AcFe24185d1b";
        }
    }

    // TODO add other chains

    throw new Error("Invalid token");
};

const getDomainParams = (
    chainId: number,
    token: Token
): {
    domainName: string;
    domainVersion: string;
} => {
    switch (token) {
        case Token.USDC:
            return {
                domainName: "USDC", // TODO check if USD Coin on mainnet
                domainVersion: "2",
            };

        // TODO add other tokens
    }
    throw new Error("Invalid token");
};

export const getEIP712Domain = (chainId: number, token: Token): TypedDataDomain => {
    const params = getDomainParams(chainId, token);
    return {
        name: params.domainName,
        version: params.domainVersion,
        chainId,
        verifyingContract: getAddress(chainId, token),
    };
};

export const permitTypes = {
    Permit: [
        { name: "owner", type: "address" },
        { name: "spender", type: "address" },
        { name: "value", type: "uint256" },
        { name: "nonce", type: "uint256" },
        { name: "deadline", type: "uint256" },
    ],
};

export const abi = [
    {
        constant: false,
        inputs: [
            {
                name: "_spender",
                type: "address",
            },
            {
                name: "_value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "owner", type: "address" }],
        name: "nonces",
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address",
            },
            {
                name: "_spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                name: "remaining",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                name: "who",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
] as const;
